import React, { useLayoutEffect, useState  } from "react";
import { withRouter } from 'react-router'
import sumBy from "lodash/sumBy"
import isEmpty from "lodash/isEmpty"
import cloneDeep from "lodash/cloneDeep"
import env from "../../env.js"

import { 
  ListGroup, 
  ListGroupItem, 
  Media,
  Card,
  CardHeader,
  CardBody,
} from 'reactstrap';

import Spinners from "../Extra/Spinners.js"

import OffSet from "../../assets/images/offsite.svg"
import PaymentMethod from "../../assets/images/payment.png"

import client from "../../feathers.js"

var upsCodes = require('ups-service-codes');

const Payment = (props) => {
  const [ spin, setSpin ] = useState(false)
  
  useLayoutEffect (() => {
    // Use props.currency to pick correct amount fields
    let items = props.carts.map(v => {
      const unitAmount = props.currency === "USD" 
        ? (v.perUnitAmount+(!isEmpty(v.variations)?sumBy(v.variations, "amount"):0))
        : (v.perUnitAmountMYR+(!isEmpty(v.variations)?sumBy(v.variations, "amountMYR"):0))
      return {
        name: v.name,
        unit_amount: {
          value: Number(unitAmount.toFixed(2)),
          currency_code: props.currency,
        },
        quantity: v.quantity,
        description: v.name
        // (!isEmpty(v.variations)?v.variations.map(v1=>{
        //   return v1.type + "-" + v1.value + "-" + (props.currency) + "" + (props.currency === "USD"? v1.totalAmount: v1.totalAmount*props.rateUSDtoMYR)
        // }):[]).toString()
      }
    })
    // Calculate both USD and MYR totals for items
    let totalItemsAmountUSD = Number((sumBy(props.carts, "totalNetAmount")+sumBy(props.carts.filter(element => !isEmpty(element.variations)).map(sum => sumBy(sum.variations, "totalAmount")))).toFixed(2))
    let totalItemsAmountMYR = Number((sumBy(props.carts, "totalNetAmountMYR")+sumBy(props.carts.filter(element => !isEmpty(element.variations)).map(sum => sumBy(sum.variations, "totalAmountMYR")))).toFixed(2))

    // shippingFee is always USD, shippingFeeMYR is always MYR
    let shippingFeeMYR = props.shippingFeeMYR || 0
    let shippingFeeUSD = props.shippingFee || 0
    
    // Pick correct amount based on currency for PayPal
    let totalItemsAmount = props.currency === "USD" ? totalItemsAmountUSD : totalItemsAmountMYR
    let shippingAmount = props.currency === "USD" ? shippingFeeUSD : shippingFeeMYR
    let totalAmount = Number((totalItemsAmount + shippingAmount).toFixed(2))
    
    // Calculate both USD and MYR total amounts
    let totalAmountUSD = Number((totalItemsAmountUSD + shippingFeeUSD).toFixed(2))
    let totalAmountMYR = Number((totalItemsAmountMYR + shippingFeeMYR).toFixed(2))

    // Clone cart and store both USD and MYR amounts for invoice
    let clonePropsCart = cloneDeep(props.carts)

    // change ups service code
    if(props.formValue.shippingCompany === 'ups'){
      props.formValue.serviceCode = upsCodes[props.formValue.serviceCode]
    }

    if(spin === false){
      const script = document.createElement("script")
      script.src = `https://www.paypal.com/sdk/js?client-id=${env.paypalClientID}&currency=${props.currency}`
      script.addEventListener("load", () => handleLoaded(
        props.currency, 
        props.rateUSDtoMYR,
        items, 
        totalItemsAmount, 
        totalAmount, 
        shippingAmount, 
        clonePropsCart, 
        props.formValue,
        props.clearCarts,
        props.history,
        props.userId,
        props.companyInfo,
        props.handleOpen,
        props.appliedVouchers,
        // USD totals (for invoice storage)
        totalItemsAmountUSD,
        totalAmountUSD,
        shippingFeeUSD,
        // MYR totals (for invoice storage)
        totalItemsAmountMYR,
        totalAmountMYR,
        shippingFeeMYR
      ))
        document.body.appendChild(script)
    }
  }, [
    props.currency, 
    props.carts, 
    props.rateUSDtoMYR, 
    props.shippingFee,
    props.shippingFeeMYR,
    props.formValue, 
    props.clearCarts,
    props.history,
    props.userId,
    props.companyInfo,
    props.handleOpen,
    spin,
    props.appliedVouchers
  ])

  const handleLoaded = (
    currency,
    rateUSDtoMYR, 
    items, 
    totalItemsAmount,
    totalAmount,  
    shippingAmount, 
    carts, 
    formValue, 
    clearCarts,
    history,
    userId,
    companyInfo,
    handleOpen,
    appliedVouchers,
    // USD totals (for invoice storage)
    totalItemsAmountUSD,
    totalAmountUSD,
    shippingAmountUSD,
    // MYR totals (for invoice storage)
    totalItemsAmountMYR,
    totalAmountMYR,
    shippingAmountMYR
  ) => {
    
    window.paypal.Buttons({

      // Set up the transaction
      createOrder: function (data, actions) {
        return actions.order.create({
          purchase_units: [{
            amount: {
              value: totalAmount,
              currency_code: currency,
              breakdown: {
                item_total: {
                  value: totalItemsAmount,
                  currency_code: currency,
                },
                shipping: {
                  currency_code: currency,
                  value: shippingAmount
                }
              }
            },
            items: items
          }]
        });
      },

      // Finalize the transaction
      onApprove: function (data, actions) {
        return actions.order.capture().then(function (paypalDetails) {
          setSpin(true)
          handleOpen(true, "success", "Thank you. Your order has been received.")
          
          // Create invoice with PayPal details - backend hook handles transaction, PDF, email
          client.service('invoices').create({
            email: formValue.email,
            firstName: formValue.firstName,
            lastName: formValue.lastName,
            address: formValue.address,
            country: formValue.country,
            state: formValue.state,
            postalCode: formValue.postalCode,
            phoneNumber: formValue.phoneNumber,
            countryCode: formValue.countryCode,
            stateOrProvinceCode: formValue.stateOrProvinceCode,

            serviceCode: formValue.serviceCode,
            shippingCompany: formValue.shippingCompany,
            
            rateUSDtoMYR: rateUSDtoMYR,
            currency: currency,
            purchaseItems: carts,
            shippingDiscPercent: formValue.shippingDiscPercent,
            shippingDiscAmount: formValue.shippingDiscAmount,
            // USD totals (always store both for reference)
            shippingAmount: shippingAmountUSD,
            totalItemsAmount: totalItemsAmountUSD,
            totalAmount: totalAmountUSD,
            // MYR totals (always store both for reference)
            shippingAmountMYR: shippingAmountMYR,
            totalItemsAmountMYR: totalItemsAmountMYR,
            totalAmountMYR: totalAmountMYR,

            appliedVouchers: appliedVouchers,
            userId: userId,

            // Pass PayPal details to backend hook
            paypalDetails: paypalDetails
          })
          .then(res => {
            // Redirect with invoice ID - getSummary finds invoice and looks up transaction
            history.push('/summary/' + res._id)
            clearCarts()
          })
          .catch(err => {
            handleOpen(true, "danger", err.message)
            
            // Log error
            client.service('write-logs').create({
              table: 'invoices',
              description: err.message,
              email: formValue.email,
              currency: currency,
              totalAmount: totalAmount,
              userId: userId,
              paymentId: paypalDetails.id,
              paymentStatus: paypalDetails.status,
              payerEmail: paypalDetails.payer.email_address,
            })
          })
        });
      },
      // onCancel: function (data) {
      //   // Show a cancel page, or return to cart
      //   console.log(data)
      // },
      onError: function (err) {
        // For example, redirect to a specific error page
        // window.location.href = "/your-error-page-here";
        handleOpen(true, "danger", ((err).toString()).substr(0, 100) + "...")
        setSpin(false)
        console.log(err)
      }
    }).render('#paypal-button-container');
  }

  return (  
    <>
      <ul className="mb-3">
        <li className="d-inline-block"><a href="/viewcart">
            Cart
          </a>
          <i className="fa fa-chevron-right mx-2"></i>
        </li>
        <li className="d-inline-block">
          <span style={{color:'#8c8c8c'}} onClick={() => props.setActiveIndex(0)}>Shipping Address</span>  
          <i className="fa fa-chevron-right mx-2"></i>
        </li>
        <li className="d-inline-block">
          <span style={{color:'#8c8c8c'}} onClick={() => props.setActiveIndex(1)}>Shipping Amount</span>
          <i className="fa fa-chevron-right mx-2"></i>
        </li>
        <li className="d-inline-block">
          <span style={{color:'#8c8c8c'}} onClick={() => props.setActiveIndex(2)}>Information</span>
          <i className="fa fa-chevron-right mx-2"></i>
        </li>
        <li className="d-inline-block">
          <span className="font-weight-bold">Payment</span>
        </li>
      </ul>
      <div className="mt-4">
        <h3>Infomation</h3>
        <ListGroup>
          <ListGroupItem className="justify-content-between">
            <Media>
              <Media body>
                Email
              </Media>
              <Media body className="text-right">
                <span className="font-weight-bold">{props.formValue.email}</span>
              </Media>
            </Media>
          </ListGroupItem>
          <ListGroupItem className="justify-content-between">
            <Media>
              <Media body>
                Name
              </Media>
              <Media body className="text-right">
                <span className="font-weight-bold">{props.formValue.firstName + " " + props.formValue.lastName}</span>
              </Media>
            </Media>
          </ListGroupItem>
          <ListGroupItem className="justify-content-between">
            <Media>
              <Media body>
                Contact
              </Media>
              <Media body className="text-right">
                <span className="font-weight-bold">{props.formValue.phoneNumber}</span>
              </Media>
            </Media>
          </ListGroupItem>
          <ListGroupItem className="justify-content-between">
            <Media>
              <Media body>
                Ship To
              </Media>
              <Media body className="text-right">
                <span className="font-weight-bold">{props.formValue.address}</span>
              </Media>
            </Media>
          </ListGroupItem>
          <ListGroupItem className="justify-content-between">
            <Media>
              <Media body>
                Country
              </Media>
              <Media body className="text-right">
                <span className="font-weight-bold">{props.formValue.country}</span>
              </Media>
            </Media>
          </ListGroupItem>
        </ListGroup>
      </div>
      <div className="mt-4">
        <h3>Payment</h3>
        <p>All transactions are secure and encrypted.</p>
        <Card>
          <CardBody className="py-2">
            <Media>
              <Media body className="align-self-center">
                Please select payment method
              </Media>
              <Media body className="text-right">
                <img src={PaymentMethod} alt="pracworks carbon" />
              </Media>
            </Media>
          </CardBody>
          <CardHeader className="text-center">
            <img className="my-3" src={OffSet} alt="pracworks"></img>
            <p>
              All Information are encrypted and sent through secured and protected channels.
            </p>
          </CardHeader>
        </Card>
      </div>
      <div className="mt-4">
        <div id="paypal-button-container" className="m-auto" style={{width: 300}}></div>
      </div>
      <Spinners 
        spinning={spin}
        content={
          <>
            <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </>
        } />
    </>
  );
}
 
export default withRouter(Payment);